// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"d48803ea","496":"414d148e"}[chunkId] + ".chunk.js";
};